import { Component, signal } from '@angular/core';
import { FrontendHeaderComponent } from '../_layout/frontend-header/frontend-header.component';
import { SectionHeaderComponent } from '../home/section-header/section-header.component';
import { skillzTeamData } from './skillz-team.data';
import { TeamMember } from './skillz-team.interface';
import { SkillzTeamCardComponent } from './skillz-team-card/skillz-team-card.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-skillz-team',
  standalone: true,
  templateUrl: './skillz-team.component.html',
  imports: [
    FrontendHeaderComponent,
    SectionHeaderComponent,
    SkillzTeamCardComponent,
    RouterLink,
  ],
})
export class SkillzTeamComponent {
  teamMembers = signal<TeamMember[]>(skillzTeamData);
}
